import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { Component, signal, Signal, viewChild, inject } from '@angular/core';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { Router, RouterModule } from '@angular/router';
import { NavigationItems } from '../../../app-core/models/navigation-item';
import NotificationComponent from '../../../app-core/ui/sidenav/notification/notification.component';
import HelpComponent from '../../../app-core/ui/sidenav/help/help.component';
import AccountComponent from '../../../app-core/ui/sidenav/account/account.component';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NotificationService } from '../../../app-core/services/notification.service';
import { MenuButton } from '../../models/menu-button.model';
import { ToolbarButton } from '../../models/toolbar-button.type';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  standalone: true,
  imports: [
    HelpComponent,
    NotificationComponent,
    AccountComponent,
    MatSidenavModule,
    MatListModule,
    RouterModule,
    MatIconModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatButtonModule,
    TranslateModule,
    MatExpansionModule
],
  providers: [
  ]
})
export class SidenavComponent {
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly notificationService = inject(NotificationService);
  private readonly router = inject(Router);

  readonly leftSidenav = viewChild.required<MatSidenav>('leftSidenav');
  readonly rightSidenav = viewChild.required<MatSidenav>('rightSidenav');
  public rightComponent: ToolbarButton | null = null;
  public menus: MenuButton[] = NavigationItems;
  public busy: Signal<boolean> = signal(true);
  public isMobile = false;

  constructor() {
    this.busy = this.notificationService.busy;
    this.breakpointObserver.observe(Breakpoints.Handset).subscribe(
      (result: BreakpointState) => this.isMobile = result.matches
    );
  }


  toggleRightMenu(component: ToolbarButton): void {
    if (this.isMobile) {
      this.router.navigate([component]);
      return;
    }

    const rightSidenav = this.rightSidenav();

    if (this.rightComponent === component && rightSidenav.opened) {
      rightSidenav.close();
      this.rightComponent = null;
      return;
    }

    this.rightComponent = component;
    rightSidenav.open();
  }

}
